import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";
import { CronogramaSGQLista } from "../../../../domain/models/cronogramaSGQ_lista";
import ItemStatus from "../../../../../../common/components/item_status";

// GenerateQualidadeIndicadoresColumns

type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeIndicadoresColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  //#region  Status
  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
        case true:
            return "Ativo";
        case false:
            return "Inativo";
        default:
            return "?";
    }
  };

  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
        case true:
            return "Ativo";
        case false:
            return "Inativo";
        default:
            return "?";
    }
  };

  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
        case true:
            return "green"; 
        case false:
            return "red"; 
        default:
            return "yellow";
    }
  };
  //#endregion

  return [
    {
    field: "Ativo", 
    filterable: false,
    headerName: "Status", 
    flex: 1,
    maxWidth: 90,
    sortable: false,
    renderCell: (params) => {
      const title = computeItemStatusTitle(params.value);
      const color = computeItemStatusColor(params.value);
      const description = computeItemStatusDescription(params.value)

      return (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={title}
            color={color}
            description={description}
          />
        </div>
      );
    }
  },
    {
      field: "Item",
      filterable: false,
      headerName: "Item",
      flex: 1,
      maxWidth: 80,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Objetivos",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Indice",
      filterable: false,
      headerName: "Índice",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Frequencia",
      filterable: false,
      headerName: "Frequência",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Meta",
      filterable: false,
      headerName: "Meta",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Resultado",
      filterable: false,
      headerName: "Resultado",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
    field: 'IdIndicador',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    minWidth: 100,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}